import {useEffect} from 'react'
import {useRouter} from 'next/router'

const useRouterScroll = (): void => {
  const router = useRouter()

  useEffect(() => {
    const handler = () => {
      window.scrollTo(0, 0)
    }

    router.events.on('routeChangeComplete', handler)

    return () => {
      router.events.off('routeChangeComplete', handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useRouterScroll
